<template>
  <div id="add-update-packet-dialog" class="custom-modal">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'updateScreenLoading' && service == null" key="create-loading" />
      <el-row v-else key="content-loading">
        <div class="modal-body">
          <el-row :gutter="10" class="tab-packet-contents" v-if="service">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.title')}}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content"><span>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.titleMsg')}}</span></div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input type="text" v-model="service.title"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>

            <el-col :span="12">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.stock')}}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content"><span>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.stockMsg')}}</span></div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input-number type="text" v-model="service.stock"></el-input-number>
              </div>
            </el-col>

            <el-col :span="12">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.stockControl')}}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content"><span>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.stockControlMsg')}}</span></div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-select v-model="service.stockControl">
                  <el-option v-for="(item, index) in getEnums.find((x) => x.title == 'RegistrationFormPacketStockControl').enums" :key="index" :label="item.displayName" :value="item.key"></el-option>
                </el-select>
              </div>
            </el-col>

            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.gallery')}}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content"><span>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.galleryMsg')}}</span></div>
                    <i v-if="imagePercent == true" class="el-icon-loading"></i>
                    <i class="el-icon-info" v-else></i>
                  </el-tooltip>
                </div>
                <el-upload class="upload-demo" drag multiple :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=additionalService&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" :on-progress="serviceImageProgress" :on-success="serviceImageSuccess">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text" v-html="$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.uploadText')"></div>
                  <div class="el-upload__tip" slot="tip" v-html="$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.uploadTextMsg')"></div>
                </el-upload>
                <div class="photo-walls mt-3">
                  <div class="photo-item" v-for="(item, index) in service.attachments" :key="index + 'image-gallery'">
                    <div class="photo-delete-icon" @click="service.attachments.splice(index, 1)">
                      <i class="fas fa-trash"></i>
                    </div>
                    <img :src="$imageus + item.url + '?width=500&height=500&mode=contain'" class="avatar" />
                  </div>
                </div>
              </div>
            </el-col>

            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.tag')}}</label>
                </div>
                <el-select v-model="service.categoryIds" multiple>
                  <el-option v-for="category in currentRegisterForm.additionalServiceCategories" :key="'additional-service-category-'+category.id" :label="category.title" :value="category.id"></el-option>
                </el-select>
                <!-- <div class="badge-container">
                  <el-tag :key="tag.title" v-for="tag in service.tags" closable :disable-transitions="false" @close="handleClose(tag)" class="mr-1">
                    {{ tag.title }}
                  </el-tag>
                  <el-input class="input-new-tag" v-if="inputVisible" v-model="tagText" ref="saveTagInput" size="mini" @keyup.enter.native="addTag" @blur="handleInputConfirm"> </el-input>
                  <el-button v-else class="button-new-tag" size="small" @click="showInput">{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.addTag')}}</el-button>
                </div> -->
              </div>
            </el-col>

            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.info')}}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content"><span>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.infoMsg')}}</span></div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <quill-editor ref="myQuillEditor" @ready="onEditorReady($event)" :options="editorOption" v-model="service.details" />
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="service.isActivePacketLimitations = !service.isActivePacketLimitations">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.packageRestriction')}}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.packageRestrictionMsg')}}</span>
                  </div>
                  <div class="section-switch" @click.stop>
                    <el-switch v-model="service.isActivePacketLimitations" @change="service.isActiveStockControl ? service.isActiveStockControl = false : ''"></el-switch>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="service.isActivePacketLimitations">
                    <div class="custom-radio-table-title">
                      <div></div>
                      <div>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.show')}}</div>
                      <div>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.required')}}</div>
                      <div>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.hide')}}</div>
                    </div>
                    <div class="custom-radio-table-title base" v-for="packet in service.packetLimitations" :key="packet.packetId + 'selectPacketd'">
                      <div v-if="currentRegisterForm.packets.some((x) => x.id == packet.packetId)">{{ currentRegisterForm.packets.find((x) => x.id == packet.packetId).title }}</div>
                      <div><el-radio v-model="packet.type" :label="0">{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.show')}}</el-radio></div>
                      <div><el-radio v-model="packet.type" :label="1">{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.required')}}</el-radio></div>
                      <div><el-radio v-model="packet.type" :label="2">{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.hide')}}</el-radio></div>
                    </div>
                  </div>
                </transition>
              </div>

              <div class="custom-section-container">
                <div class="section-header" @click="service.isActivePacketLimitations ? (service.isActiveStockControl = !service.isActiveStockControl) : ''">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.limitSettings')}}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                        <i class="el-icon-info"></i>
                      </el-tooltip> -->
                    </div>
                    <span>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.limitSettingsMsg')}}</span>
                  </div>
                  <div class="section-switch" @click.stop>
                    <el-switch v-model="service.isActiveStockControl" :disabled="!service.isActivePacketLimitations"></el-switch>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="service.isActiveStockControl">
                    <div class="custom-radio-stock-controller">
                      <div class="custom-radio-table-title stock">
                        <div>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.package')}}</div>
                        <div>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.limit')}}</div>
                      </div>
                      <template v-if="service.packetLimitations.filter((x) => x.type != null && x.type != 2).length > 0">
                        <div class="custom-radio-table-title  stock-row" v-for="packet in service.packetLimitations.filter((x) => x.type != null && x.type != 2)" :key="packet.packetId + 'testrow'">
                          <div v-if="currentRegisterForm.packets.length > 0">{{ currentRegisterForm.packets.find((x) => x.id == packet.packetId).title }}</div>
                          <div><el-input-number :min="1" v-model="packet.stock"></el-input-number></div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="custom-radio-table-title  stock-row" v-for="packet in service.packetLimitations.filter((x) => x.type != 2)" :key="packet.packetId + 'testrow'">
                          <div v-if="currentRegisterForm.packets.length > 0">{{ currentRegisterForm.packets.find((x) => x.id == packet.packetId).title }}</div>
                          <div><el-input-number :min="1" :max="service.stock" v-model.number="packet.stock"></el-input-number></div>
                        </div>
                      </template>
                    </div>
                  </div>
                </transition>
              </div>

              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.settings')}}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.settingsMsg')}}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="service.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="service.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.view')}}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.viewMsg')}}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="service.isActive"></el-switch>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-row>
    </transition>

    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && service != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.close')}}</el-button>
        <template v-if="id != null">
          <el-popconfirm
            @confirm="deleteItem"
            :confirmButtonText="$t('event.variables.yes')"
            :cancelButtonText="$t('event.buttons.cancel')"
            icon="el-icon-info"
            iconColor="red"
            :title="$t('event.textbox.toDelete')"
          >
            <el-button slot="reference" type="danger" icon="fas fa-trash"> {{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.delete')}}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'serviceSave'" :disabled="loading == 'serviceSave'" @click="saveService()">{{$t('registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.save')}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios"
  import draggable from "vuedraggable"
  import { quillEditor } from "vue-quill-editor"
  export default {
    props: ["id", "formId"],
    components: {
      quillEditor,
      draggable,
    },
    data() {
      return {
        axios,
    
        settingsDock: false,
        imagePercent: false,
        inputVisible: false,
        tagText: null,
        packet: null,
        service: null,
        loading: false,
        validationErrors: [],
        drag: false,
        currDate: new Date().getTime(),
        timeout: null,
        editorOption: {
          modules: {
            toolbar: [["bold", "italic", "underline", "strike"],[{ 'indent': '-1'}, { 'indent': '+1' }],],
            syntax: {
              highlight: (text) => hljs.highlightAuto(text).value,
            },
          },
        },
      }
    },
    computed: {
      dragOptions() {
        return {
          animation: 200,
          group: "description",
          disabled: false,
          ghostClass: "ghost",
        }
      },
      packetForm() {
        return this.$store.getters.getRegistrationPacketForm
      },
      serviceForm() {
        return this.$store.getters.getRegistrationServiceForm
      },
      currentRegisterForm() {
        return this.$store.getters.getCurrentRegisterForm
      },
      tagList() {
        return this.$store.getters.getTagsList
      },
      getEnums() {
        return this.$store.getters.getEnums
      },
    },
    async created() {
      await this.checkedId()
    },
    methods: {
      deleteItem(){
        this.$emit('deleteMe', this.id);
        this.$emit('closeDialog');
      },
      handleClose(tag) {
        this.service.tags.splice(this.service.tags.indexOf(tag), 1)
      },
      serviceImageProgress(){
        this.imagePercent = true;
      },
      serviceImageSuccess(response) {
        if (response.alert.hasError) {
          this.$message.error(response.alert.message)
        } else {
          this.$message.success(response.alert.message)
          this.service.attachments.push({ url: response.data.item.url })
        }
        this.imagePercent = false;
      },
      addTag() {
        let inputValue = this.tagText
        if (inputValue) {
          this.service.tags.push({ title: this.tagText })
        }
        this.tagText = null
        this.inputVisible = false
      },

      showInput() {
        this.inputVisible = true
        this.$nextTick((_) => {
          this.$refs.saveTagInput.$refs.input.focus()
        })
      },
      async saveService() {
        if (this.timeout != null) clearTimeout(this.timeout)
        this.loading = "serviceSave"

        this.timeout = setTimeout(async () => {
          var res = await this.$store.dispatch("addOrUpdateRegisterService", this.service)
          this.validationErrors = res.data.validationErrors
          if (!res.data.alert.hasError) {
            this.closeMe()
          }
          this.loading = false
        }, 500)
      },

      closeMe() {
        this.$emit("closeDialog")
      },
      addDayRestrictions() {
        this.packet.dayRestrictions.push({
          id: null,
          title: "Yeni Gün",
          date: null,
          isActive: true,
        })
      },
      addPricingOption() {
        this.packet.priceOptions.push({
          id: null,
          title: this.$t('generic.newOption'),
          startDate: null,
          endDate: null,
          price: 0,
          isActive: true,
        })
      },
      onEditorReady(editor) {
        editor.getModule("toolbar").addHandler("image", () => {
          this.selectLocalImage(editor)
        })
      },
      async checkedId() {
        this.loading = "updateScreenLoading"
        if (this.timeout != null) clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          if (this.id) {
            this.service = JSON.parse(JSON.stringify(this.currentRegisterForm.additionalServices.find((x) => x.id == this.id)))
            this.service.packetLimitations = this.service.packetLimitations.filter(x =>  this.currentRegisterForm.packets.some(y => y.id == x.packetId))
          } else {
            this.service = JSON.parse(JSON.stringify(this.serviceForm))
            this.service.registrationFormId = this.formId
            this.service.packetLimitations = [];
            this.currentRegisterForm.packets.map((x) => {
              var payload = {
                packetId: x.id,
                title: x.title,
                stock: x.stock,
              }
              this.service.packetLimitations.push(payload)
            })
          }
          this.loading = false
        }, 500)
      },
    },
    watch: {
      id() {
        this.checkedId()
      },
    },
  }
</script>

<style lang="less">
  .tab-packet-contents {
    & > .el-col {
      margin-bottom: 1rem;
    }
    .el-input-number {
      width: 100%;
    }
    .registerform-input-container {
      .tag-container {
        gap: 1rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
      .badge-list {
        display: flex;
        flex-direction: row;
        gap: 1rem;
        .badger {
          border-radius: 8px;
          background-color: #f3f3f3;
          height: 20px;
          padding: 10px;
        }
      }
      .title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.5rem;
        label {
          font-weight: bold;
          color: black;
          margin-bottom: 0;
        }
        .title-container {
          display: flex;
          flex-direction: row;
          gap: 1rem;
          align-items: center;
          margin-top: 1rem;
        }
      }
      display: flex;
      flex-direction: column;
      .el-input-number {
        width: 100%;
      }
    }
    .el-upload {
      width: 100%;
      .el-upload-dragger {
        height: 120px;
        .el-icon-upload {
          font-size: 30px;
          margin: 0;
        }
      }
    }
    .packet-head {
      display: grid;
      grid-template-columns: 2fr 1fr 2fr 1fr 1fr;
      border-radius: 5px;
      border: 1px solid #ccc;
      padding: 10px;
      font-weight: bold;
    }
  }
  .add-update-packet-dialog {
    .el-dialog__body {
      padding: 10px 20px;
    }
  }
  .add-update-packet-dialog-container {
    .bottom {
      margin-top: 1rem;
      display: flex;
      justify-content: flex-end;
      gap: 1rem;
    }
  }

  .add-pricing-btn {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .input-new-tag {
    width: 100px;
  }
  .photo-walls {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    img {
      width: 100px;
      height: 100px;
      object-fit: cover;
    }
    .photo-item {
      position: relative;
      .photo-delete-icon {
        position: absolute;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          color: white;
          font-size: 12px;
        }
        border-radius: 50%;
        background-color: red;
        cursor: pointer;
        right: -0.2rem;
        top: -0.1rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/register-form/addOrUpdateRegistrationService.vue